export const STAT_CARD_CONFIG = [
    { key: 'totalDevices', title: 'Total',         subtitle: 'Devices',      icon: 'pi-server',       colorClass: 'stat-blue'   },
    { key: 'reachable',    title: 'Reachable',     subtitle: 'Devices',      icon: 'pi-check-circle', colorClass: 'stat-green'  },
    { key: 'unreachable',  title: 'Not Reachable', subtitle: 'Devices',      icon: 'pi-times-circle', colorClass: 'stat-red'    },
    { key: 'avgLatencyMs', title: 'Avg Latency',   subtitle: 'Milliseconds', icon: 'pi-chart-line',   colorClass: 'stat-orange' }
];

export const LINE_COLORS = [
    '#2196F3', '#4CAF50', '#F44336', '#FF9800', '#9C27B0',
    '#00BCD4', '#FF5722', '#607D8B', '#E91E63', '#3F51B5'
];

export const TIME_RANGE_OPTIONS = [
    { label: 'Last 6 Hours',  value: 6  },
    { label: 'Last 12 Hours', value: 12 },
    { label: 'Last 24 Hours', value: 24 },
    { label: 'Last 48 Hours', value: 48 }
];